import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowWallUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowWallUp"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2H20V3.5H4V2ZM12 5.68934L17.3107 11L16.25 12.0607L12.75 8.56067V22H11.25V8.56065L7.75 12.0607L6.68934 11L12 5.68934Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowWallUp;
